<div class="popup-wrapper">
    <div class="popup-header">
        <span class="material-icons cyan">tune</span>
        <span class="soc-panel-h">{{'TURNOVER.FILTER' | translate}}</span>
    </div>
    <hr class="soc-panel-line">  

    <div class="soc-input-wrapper">
        <label for="name" class="soc-input-lbl w-100 text-start">{{'TURNOVER.ORDER_NUMBER'| translate}}</label>
        <input type="number" class="soc-input-field soc-input-text" placeholder="{{'SEARCH' | translate}}" [(ngModel)]="searchModel.orderNumbers">
    </div>

    <div class="soc-wrapper-gap-12">
        <div>
            <label class="soc-input-lbl w-100 text-start">{{'TURNOVER.FROM'| translate}}</label>
            <div class="soc-calendar-timeonly">
                <span class="material-icons clock-icon">watch_later</span>
                <p-calendar class="soc-calendar-timeonly" [(ngModel)]="searchModel.from" [readonlyInput]="true" [timeOnly]="true" hourFormat="12" [showClear]="true" placeholder="{{'SELECT_SEARCH' | translate}}" (onFocus)="setDefaultFromDate()"></p-calendar>
            </div>
        </div>
        <div>
            <div class="d-flex justify-content-between">
                <label class="soc-input-lbl w-100 text-start">{{'TURNOVER.UNTIL'| translate}}</label>
                <label *ngIf="searchModel.from && searchModel.until && searchModel.until < searchModel.from" class="soc-input-lbl w-100 text-end soc-cyan-color">{{'TURNOVER.NEXT_DAY'| translate}}</label>
            </div>
            <div class="soc-calendar-timeonly">
                <span class="material-icons clock-icon">watch_later</span>
                <p-calendar class="soc-calendar-timeonly" [(ngModel)]="searchModel.until" [readonlyInput]="true" [timeOnly]="true" hourFormat="12" (onFocus)="setDefaultUntilDate()" [showClear]="true" placeholder="{{'SELECT_SEARCH' | translate}}"></p-calendar>
            </div>
        </div>
    </div>

    <div class="soc-input-wrapper">
        <label class="soc-input-lbl w-100 text-start">{{'TURNOVER.GROUPS' | translate}}</label>
        <p-multiSelect appendTo="body" class="soc-multiselect" [showClear]="true" [virtualScroll]="true" [filter]="true" filterBy="name" [options]="groups" [(ngModel)]="searchModel.groups" placeholder="{{'SELECT_SEARCH' | translate}}" [showClear]="true">
            <ng-template let-groups pTemplate="selectedItems">
                <div *ngIf="!groups || groups.length == 0">{{'SELECT_SEARCH' | translate}}</div>
                <div *ngIf="groups && groups.length == 1">{{ groups[0].name }}</div>
                <div *ngIf="groups && groups.length > 1" class="multiple-selected">{{ groups.length }} Selected</div>
            </ng-template>
            <ng-template let-group pTemplate="item">
                <span>{{group.name}}</span>
            </ng-template>
        </p-multiSelect>
    </div>
    <div class="soc-input-wrapper">
        <label class="soc-input-lbl w-100 text-start">{{'TURNOVER.TABLES' | translate}}</label>
        <p-multiSelect appendTo="body" class="soc-multiselect" [showClear]="true" [virtualScroll]="true" filterBy="name" optionLabel="name" optionValue="name" [options]="tables" [(ngModel)]="searchModel.tables" placeholder="{{'SELECT_SEARCH' | translate}}" [showClear]="true">
            <ng-template let-tables pTemplate="selectedItems">
                <div *ngIf="!tables || tables.length == 0">{{'SELECT_SEARCH' | translate}}</div>
                <div *ngIf="tables && tables.length == 1">{{ tables[0] }}</div>
                <div *ngIf="tables && tables.length > 1" class="multiple-selected">{{ tables.length }} Selected</div>
            </ng-template>
        </p-multiSelect>
    </div>
    <div class="soc-input-wrapper">
        <label class="soc-input-lbl w-100 text-start">{{'TURNOVER.WAITERS' | translate}}</label>
        <p-multiSelect appendTo="body" class="soc-multiselect" [showClear]="true" [virtualScroll]="true" [filter]="true" filterBy="firstName, lastName" [options]="waiters" [(ngModel)]="searchModel.waiters" placeholder="{{'SELECT_SEARCH' | translate}}"[showClear]="true">
            <ng-template let-users pTemplate="selectedItems">
                <div *ngIf="!users || users.length == 0">{{'SELECT_SEARCH' | translate}}</div>
                <div *ngIf="users && users.length == 1">{{ users[0].firstName }} {{ users[0].lastName }}</div>
                <div *ngIf="users && users.length > 1" class="multiple-selected">{{ users.length }} Selected</div>
            </ng-template>
            <ng-template let-user pTemplate="item">
                <span>{{user.firstName}} {{user.lastName}}</span>
            </ng-template>
        </p-multiSelect>
    </div>
    <div class="soc-input-wrapper">
        <label class="soc-input-lbl w-100 text-start">{{'TURNOVER.PRINT_TYPE' | translate}}</label>
        <p-dropdown [required]="true" class="soc-dropdown soc-dropdown-search-separator" appendTo="body" [virtualScroll]="true" optionLabel="key" optionValue="value" [options]="printerTypes" [(ngModel)]="searchModel.orderType" [showClear]="true"  placeholder="{{'SELECT_SEARCH' | translate}}" filterPlaceholder="{{'SEARCH' | translate}}"></p-dropdown>
    </div>
    
    <hr class="soc-panel-line">
    <div class="d-flex justify-content-between">
        <button class="soc-basic-orange-btn" (click)="clear()">{{"CLEAR_ALL" | translate}}</button>
        <div class="soc-wrapper-gap-12 d-flex justify-content-end">
            <button class="soc-secondary-cyan-btn" (click)="cancel()">{{'CANCEL' | translate}}</button>
            <button class="soc-basic-cyan-btn" (click)="filter()">{{'FILTER' | translate}}</button>
        </div>
    </div>
</div>
